export default __webpack_public_path__ + "static/media/tick.b043eadb.svg";